import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import auth from "./auth.reducer";
import licenseBundles from "./license-bundles.reducer";
import bundles from "./bundles.reducer";
import common from "./common.reducer";
import customerGroups from "./customer-groups.reducer";
import customers from "./customers.reducer";
import deleteSummary from "./delete.reducer";
import features from "./features.reducer";
import productGroups from "./product-groups.reducer";
import products from "./products.reducer";
import purchases from "./purchases.reducer";
import subscriptionOwners from "./subscriptionOwners.reducer";
import resources from "./resources.reducer";
import vatsReducer from "./vats.reducer";
import exportCustomersReportReducer from "./exportCustomersReport.reducer";
import siteSettings from "./tenant.reducers";
import tenantCurrenciesReducer from "./tenantCurrencies.reducer";

const rootReducer = history =>
  combineReducers({
    auth,
    licenseBundles,
    bundles,
    common,
    customerGroups,
    customers,
    deleteSummary,
    features,
    productGroups,
    products,
    purchases,
    subscriptionOwners,
    resources,
    vatsReducer,
    exportCustomersReportReducer,
    siteSettings,
    tenantCurrenciesReducer,
    router: connectRouter(history)
  });

export default rootReducer;
